import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, border } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { DsiAddressBlock as AddressBlock } from './AddressBlock';
import { DsiNewAddressBlock as NewAddressBlock } from './NewAddressBlock';
import { useState } from 'react';

interface Props {
  addresses: any[];
  onAddressClick: (id) => void;
  currentId: number | null;
  isB2B?: boolean;
  smallBoxes?: boolean;
}

function AddressesDeliveryList({
  addresses,
  onAddressClick,
  currentId,
  isB2B,
  smallBoxes,
}: Props) {
  // zatial
  // const [active, setActive] = useState(true);
  // const handleClick = () => {
  //   setActive(!active);
  // };
  return (
    <Wrapper>
      {addresses &&
        addresses.map(address => (
          <>
            <AddressBlock
              /* tslint:disable-next-line:jsx-no-lambda */
              onClick={() => onAddressClick(address.id)}
              key={address.id}
              address={address}
              active={currentId === address.id}
            />
          </>
        ))}
      {/*<AddressBlock onClick={onAddressClick} key={1} active={true} />*/}
      {!isB2B && (
        <NewAddressBlock active={currentId === null} onClick={onAddressClick} />
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.m580`
    margin-bottom: 0;
  `}
`;

export { AddressesDeliveryList as DsiAddressesDeliveryList };
